import rt from 'vue-routes-generator'
import Auditor from './App'
import Buscador from './componentes/buscador/buscador'
export default {
	install: Vue => {
		rt.route('/main').child('auditor', {
			component: Auditor,
			redirect: '/main/auditor/buscador'
		})

		rt.route('/main').child('auditor').child('buscador', {
			component: Buscador,
			name: 'Buscador de emisiones'
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/auditor/vue/index.js